import { VueContentPopover } from "./VueContentPopover";
import { translations } from "../../shared/localization/translations";
import PaymentMethodsReportPopover from "../../components/order/PaymentMethodsReportPopover.vue";
import type { IPaymentMethodsReportData } from "@/data/model/PaymentMethodsReportData";

export class PaymentMethodsReportContentPopover extends VueContentPopover {
    constructor(onExportPaymentMethod: (data: IPaymentMethodsReportData) => void) {
        super({
            title: translations.report.paymentMethodsReport,
            uniqueId: "payment-methods-report-popover",
            flexHeight: true,
            condensed: true,
        });

        this.initComponent(PaymentMethodsReportPopover, {
            onExportPaymentMethod: onExportPaymentMethod
        }, true);
    }
}